import React from 'react'
import TestimonialOne from '../Components/Testimonial/TestimonialOne'
import PageBanner from '../Components/PageBanner'
import bannerBg from '../assets/img//Banners/History.jpg';
import ServicesFour from '../Components/Services/ServicesFour';
import AboutFour from '../Components/About/AboutFour';
import OurSkill from '../Components/Skills/OurSkill';
import FaqTwo from '../Components/Faq/FaqTwo';
import FaqOne from '../Components/Faq/FaqOne';
import MyFaq from '../Components/Faq/MyFaq';
import ServicesThree from '../Components/Services/ServicesThree';

const History = () => {
  return (
    <>
     <PageBanner title='History  ' bannerBg={bannerBg} currentPage='History' />
     <OurSkill/>
     <MyFaq/>
    
     <TestimonialOne/>
     <ServicesThree/>
    </>
  )
}

export default History
